"use client";

import React from "react";
import { cn } from "@/lib/utils";

interface ToggleSwitchProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  wrapperClassName?: string;
}

const ToggleSwitch = React.forwardRef<HTMLInputElement, ToggleSwitchProps>(
  ({ label, error, wrapperClassName, className, ...props }, ref) => {
    return (
      <div className={cn("flex", wrapperClassName)}>
        

        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            ref={ref}
            className="sr-only peer"
            {...props}
          />
          <div
            className={cn(
              "group peer ring-0 rounded-full outline-none duration-300 after:duration-300 w-11 h-6 shadow-md bg-gray-400 peer-checked:bg-emerald-600 peer-focus:outline-none after:rounded-full after:absolute after:bg-gray-50 after:outline-none after:h-4 after:w-4 after:top-1 after:left-1 after:flex after:justify-center after:items-center peer-checked:after:translate-x-5  peer-hover:after:scale-95",
              className
            )}
          ></div>
        </label>
        {label && (
          <label className="text-sm text-muted font-medium block mb-1">
            {label}
          </label>
        )}

        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
      </div>
    );
  }
);

ToggleSwitch.displayName = "ToggleSwitch";

export default ToggleSwitch;
